import { Parameter } from "../../common/types/parameters";
import { getAsAlternative } from "../../components/parameters/util";
import { Condition } from "./types";

export function isMet(condition: Condition, parameters: Parameter[]) {
  if (condition.value === undefined) {
    return true;
  }

  let parameter = parameters.find((p) => p.id === condition.parameter);

  if (parameter === undefined) {
    return false;
  }

  if (
    parameter.value === condition.value ||
    parameter.value === JSON.stringify(condition.value)
  ) {
    return true;
  }

  let selectedAlternative = getAsAlternative(parameter.value);
  if (selectedAlternative !== undefined) {
    return (
      selectedAlternative.value === condition.value ||
      selectedAlternative.value === JSON.stringify(condition.value)
    );
  }

  return false;
}
